// Pool of marcs shown on the landing-page cycling preview. Today this is
// exactly the set of marcs that have committed reference drawings —
// effectively the same as AVAILABLE_MARC_IDS. The split exists because
// the two pools will diverge: speedrun needs marcs that are tractable
// in 60s on a per-region basis, but the landing reel is happy to show
// off heavy detail traces as eye candy. When that distinction starts
// to matter, the simplest extension is a `landingOnly: true` flag in
// reference.json that gen-manifest emits as a second array.
import { AVAILABLE_MARC_IDS } from "./marcManifest";

export const LANDING_MARC_IDS = AVAILABLE_MARC_IDS;
